<template>
  <b-row>
    <JsonField
      v-model="data"
      name="data"
      class="col-12"
      @error="setHasError(true)"
      @input="setHasError(false)"
    />
    <FormActions :on-submit="save" :on-cancel="cancel" />
  </b-row>
</template>
<script>
import ModalMixin from '@/General/Modal/ModalMixin.js'

export default {
  name: 'EditModelDataModal',

  mixins: [ ModalMixin ],

  props: {
    meta: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    return {
      data: this.meta.data || null,
      hasError: false
    }
  },

  methods: {
    save() {
      if (this.hasError) {
        this.$errorToast(this.__('error.invalid-json-structure'))
        return
      }

      this.meta.onSave && this.meta.onSave(this.generatePayload())
        .then(() => this.closeModal())
        .catch(error => this.setErrorsFromResponse(error))
    },

    setHasError(value = false) {
      this.hasError = value
    },

    cancel() {
      this.closeModal()
    },

    generatePayload() {
      return {
        data: this.data,
      }
    }
  }
}
</script>
